import { FormattedMessage } from 'react-intl'
import { FormControlLabel, Switch } from '@mui/material'
import { Button, DialogFooter, Typography } from '@carto/meridian-ds/components'

interface NewExportActionsProps {
  submitting: boolean
  disabled?: boolean
  sqlEditor: boolean
  onSqlEditorVisibleChange: (value: boolean) => void
  onSubmit: () => void
}

function NewExportActions({
  submitting,
  disabled,
  sqlEditor,
  onSqlEditorVisibleChange,
  onSubmit
}: NewExportActionsProps) {
  const handleSQLEditorVisibilityChanges = () => {
    onSqlEditorVisibleChange(!sqlEditor)
  }
  return (
    <DialogFooter
      secondaryActions={
        <FormControlLabel
          control={
            <Switch checked={sqlEditor} onChange={handleSQLEditorVisibilityChanges} data-testid="SqlEditorSwitch" />
          }
          label={
            <Typography variant="body2">
              <FormattedMessage id="data-explorer.subscription.exportDialog.sqlEditor" />
            </Typography>
          }
        />
      }
    >
      <Button loading={submitting} disabled={disabled} onClick={onSubmit} variant="contained">
        <FormattedMessage id="data-explorer.subscription.exportDialog.submit" />
      </Button>
    </DialogFooter>
  )
}

export default NewExportActions
